import { StoreCard } from '@/components/common/StoreCard';
import { formatDistance } from '@/lib/distance';
import { getTodayOperatingHours } from '@/lib/operatingHours';
import { type RestaurantWithProduct } from '@/types';

interface StoreListWrapperProps {
  restaurants: RestaurantWithProduct[];
  selectedOrderType: 'DEADLINE_DISCOUNT' | 'RESERVATION_DISCOUNT' | 'REGULAR_ORDER';
  favoriteStores: Set<string>;
  onStoreCardClick: (storeId: string) => void;
  onFavoriteToggle: (storeId: string) => void;
}

export function StoreListWrapper({ 
  restaurants, 
  selectedOrderType, 
  favoriteStores,
  onStoreCardClick,
  onFavoriteToggle
}: StoreListWrapperProps) {
  
  if (restaurants.length === 0) {
    return (
      <div className="bg-white rounded-lg p-12 text-center">
        <p className="text-lg font-semibold text-gray-700">
          판매자 등록이 진행중이에요. 곧 만나요!
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
      {restaurants.map((restaurant) => {
        // Get today's operating hours using helper function
        const todayHours = getTodayOperatingHours(restaurant as any);
        
        return (
          <div key={restaurant.id} className="w-full">
            <StoreCard
              id={restaurant.id}
              name={restaurant.name}
              bestmenu={restaurant.bestmenu}
              bestmenu1={restaurant.bestmenu1}
              bestmenu2={restaurant.bestmenu2}
              bestmenu3={restaurant.bestmenu3}
              pickupInstructions={restaurant.pickup_instructions}
              products={restaurant.products?.map((product: any) => ({
                id: product.id,
                name: product.name,
                original_price: product.original_price,
                image_url: product.image_url,
                offers: product.offers || [],
                current_stock: product.stock?.[0]?.current_stock || 0,
                is_available: product.is_available ?? true
              }))}
              isOpen={restaurant.isOrderAvailable ?? restaurant.is_open}
              isNew={restaurant.is_new}
              storeType={restaurant.store_type}
              imageUrl={restaurant.image_url}
              distance={restaurant.distance ? formatDistance(restaurant.distance) : undefined}
              onCardClick={() => onStoreCardClick(restaurant.id)}
              onFavoriteToggle={() => onFavoriteToggle(restaurant.id)}
              isFavorite={favoriteStores.has(restaurant.id)}
              selectedOrderType={selectedOrderType}
              deadlineDiscountStartTime={restaurant.deadline_discount_start_time}
              deadlineDiscountEndTime={restaurant.deadline_discount_end_time}
              todayStart={todayHours.openTime}
              todayEnd={todayHours.closeTime}
              // 예약할인을 위한 필수 데이터 추가
              operating_hours={(restaurant as any).operating_hours}
              reservation_discount_enabled={(restaurant as any).reservation_discount_enabled}
              reservation_available_start={(restaurant as any).reservation_available_start}
              reservation_available_end={(restaurant as any).reservation_available_end}
              // Desktop specific props
              platform="desktop"
              size="large"
            />
          </div>
        );
      })}
    </div>
  );
}